import {SubjectPaymentList} from "./SubjectPaymentList";
import SubjectPaymentEdit from "./SubjectPaymentEdit";
import {SubjectPaymentCreate} from "./SubjectPaymentCreate";

export default {
    list: SubjectPaymentList,
    create: SubjectPaymentCreate,
    edit: SubjectPaymentEdit
};
